export default __webpack_public_path__ + "static/media/icons8-maintenance-100.aa95d5b4.svg";